import axios from '../axios';

export const MATERIAL_TYPES = {
    obituary: 'Nekrolog',
    cross_plaque: 'Tabliczka na krzyż',
    candle_plaque: 'Tabliczka na znicz',
    coffin_plaque: 'Tabliczka na trumnę',
    urn_plaque: 'Tabliczka na urnę',
    black_obituary: 'Nekrolog czarny',
    thank_you: 'Podziękowanie',
    sash: 'Szarfa'
};

const LAYOUT_MATERIAL_TYPES = {
    1: 'obituary',
    2: 'cross_plaque',
    3: 'candle_plaque',
    4: 'coffin_plaque',
    5: 'urn_plaque',
    6: 'black_obituary',
    7: 'thank_you'
};

const LAYOUT_ID_MATERIAL_TYPES = {
    'obituary-minimalizm': 'obituary',
    'obituary-pogrubione': 'obituary',
    'obituary-black': 'black_obituary',
    'thank-you': 'thank_you',
    'cross-plaque': 'cross_plaque',
    'snitch-plaque': 'candle_plaque',
    'coffin-plaque': 'coffin_plaque',
    'urn-plaque': 'urn_plaque'
};

export const getMaterialTypeForLayout = (layoutType, layoutId) => (
    LAYOUT_ID_MATERIAL_TYPES[layoutId]
    || LAYOUT_MATERIAL_TYPES[String(layoutType)]
    || null
);

export const getMaterialTypeLabel = materialType => (
    MATERIAL_TYPES[materialType] || 'Nieznany typ'
);

export const recordDownload = (materialType, fileFormat) => {
    if (!materialType) {
        return Promise.reject(new Error('Nie można rozpoznać typu pobieranego materiału.'));
    }

    return axios.post('/increment-downloads', { materialType, fileFormat });
};